import __vue_component__ from './IconWrapper.vue.js';

var Gif48Icon = {
  name: 'Gif48Icon',
  props: {
    size: {
      type: String
    },
    primaryColor: {
      type: String
    },
    secondaryColor: {
      type: String
    }
  },

  render(h) {
    // eslint-disable-next-line max-len
    return h(__vue_component__, {
      props: { ...this.$props
      },
      domProps: {
        innerHTML: '<svg viewBox="0 0 48 64"><g fill-rule="evenodd"><path fill="#FFF" stroke="#091E42" stroke-opacity=".08" d="M4 .5h28.007a3.5 3.5 0 0 1 2.52 1.072l11.994 12.45a3.5 3.5 0 0 1 .979 2.429V60a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 60V4A3.5 3.5 0 0 1 4 .5z"/><path fill="#FFAB00" d="M25.824 37.409h-2.252a.283.283 0 0 1-.284-.284v-9.343c0-.158.126-.284.284-.284h2.252c.157 0 .284.126.284.284v9.343a.284.284 0 0 1-.284.284zm4.423 0h-2.254a.284.284 0 0 1-.283-.284v-9.343c0-.158.127-.284.283-.284h6.223c.156 0 .284.126.284.284v1.834a.285.285 0 0 1-.284.284H30.53v1.657h3.323c.157 0 .284.127.284.284v1.772a.284.284 0 0 1-.284.284H30.53v3.228a.285.285 0 0 1-.283.284m-12.33.17c-2.765 0-4.417-1.717-4.417-4.595v-1.123c0-2.793 1.695-4.528 4.425-4.528 2.7 0 4.01 1.712 4.109 3.41a.282.282 0 0 1-.283.3h-2.19a.284.284 0 0 1-.28-.233c-.117-.642-.645-1.04-1.377-1.04-1.293 0-1.564 1.148-1.564 2.112v1.095c0 1.437.546 2.166 1.626 2.166 1.033 0 1.4-.628 1.4-1.167v-.107H18.02a.283.283 0 0 1-.284-.283v-1.602c0-.157.127-.284.284-.284h3.752c.156 0 .284.127.284.284v1.814c0 1.745-1.085 3.781-4.138 3.781"/></g></svg>'
      }
    });
  }

};

export default Gif48Icon;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Icon/Gif48Icon.js